export { default } from "./getEntityForUserRole";
